import React, { useEffect, useState, useMemo } from 'react'
import Select from "react-select";

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import { Badge } from 'react-bootstrap';
import ConfirmationAlert from '../Alerts/ConfirmationAlert';
import printOrderData from './PrintOrderData';
import AlertSmall from '../Alerts/AlertSmall';
import Modalclient from './ModalClients';
import ClientPillCard from '../ClientPillCard/ClientPillCard';
import PhoneInput from 'react-phone-input-2';
import ModalQuoteDetails from './ModalQuoteDetails';
import Swal from "sweetalert2";

//API 
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { TablesFetchAPI } from '../../api/Tables';
import { BranchOfficeEnvironmentsFetchAPI } from '../../api/BranchOfficeEnvironments';
import { PrinterFetchAPI } from '../../api/Printer';
import { MachinesFetchAPI } from '../../api/Machines';
import { AuthDgiFetchAPI } from '../../api/Paymentpost/AuthDgi';
import { PreOrderFetchAPI } from '../../api/Paymentpost/PreOrder';
import { CategriesPosFetchAPI } from '../../api/Paymentpost/CategoriesPos';
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';
import { ClientsFetchAPI } from '../../api/Clients';
import { MailFetchAPI } from '../../api/Mail';
import { OrdersFetchAPI } from '../../api/Orders';
//Utils
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
import { showApiError } from '../../utils/ApiError';
import { hasPreOrderKitchenItemsToPrint } from '../../utils/PreOrderPaymentPrint';
//IMG
import defaultImage from "../../assets/img/default.png";
import { createPortal } from "react-dom";

//UI
import PaySheet from './PaySheet/PaySheet';
import "./css/qmdl.css";


function ModalCreatePreOrder({ checkDeliveryOrder,
   branchoffice, token,
   removedPreOrderShoppingCartProducts,
   dv, name, ruc, setDv, setName,
   setRuc, dataResponse, optionalData,
   setDataResponse, setOptionalData,
   shoppingCart, shoppingCartCombos,
   total, subtotal, tax, discount,
   setPageLoader, dataPreOrder, taxesArrayAll,
   cardGroup, dataDicountApply, paramsMicros,
   parthner_order, parthners, setdataClientSelected, dataClientSelected,
   addressNowLocation, setAddressNowLocation, setShoppingCart,
   calculateInvoiceTotals, enabledOnlineOrder, selectRestaurant,
   setResetData, setShoppingCartCombos, selectPreOrder, dataStyleBusiness,
   domain, setSelectPreOrder, aditional_data, setAditional_data,
   addresDescriptionClientFiscal, setAddresDescriptionClientFiscal, eventDataState, events }) {


   const [domainBusiness, setDomainBusiness] = useState(() => {
      const storedDomain = localStorage.getItem('business');
      return storedDomain ? JSON.parse(storedDomain).domain : '';
   });
   const [eventDates, setEventDates] = React.useState([]);
   const [selectedEvent, setSelectedEvent] = React.useState(null);
   // Estado para modal de detalles de cotización
   const [showQuoteDetails, setShowQuoteDetails] = useState(false);
   const [selectedQuote, setSelectedQuote] = useState(null);
   // Popup de totales
   const [showTotals, setShowTotals] = useState(false);
   let logo = localStorage.getItem('businessLogo');

   const eventsAndDates = () => {
      return (<>
         {events.length > 0 &&
            <div className="qmdl-field">
               <label className="qmdl-label" htmlFor="qmdl-event">Evento</label>
               <select
                  id="qmdl-event"
                  className="qmdl-input"
                  value={selectedEvent ? selectedEvent.id : ''}
                  onChange={e => {
                     const eventObj = events.find(ev => String(ev.id) === String(e.target.value));
                     setSelectedEvent(eventObj);
                  }}
               >
                  <option value={null}>Selecciona un evento</option>
                  {(events || [])
                     .map(ev => (
                        <option key={ev.id} value={ev.id}>
                           {ev.name}
                        </option>
                     ))}
               </select>
            </div>
         }
      </>)
   }



   const [email, setEmail] = useState("");
   const [email_cc, setEmail_cc] = useState("");
   const [phone, setPhone] = useState("");
   const [formType, setFormType] = useState("preOrder");
   const [show, setShow] = useState(false);
   const [note, setNote] = useState(() => { if (selectPreOrder?.note) { return selectPreOrder.note } else { return "" } });
   const [infoPrinter, setInfoPrinter] = useState({ printer_comanda: "", printer_ticket: "", printer_ip: "" })
   const [printers, setPrinters] = useState([]);
   const [dataOrder, setDataOrder] = useState({});
   const [tableNumber, setTableNumber] = useState(0);
   const [stateRequest, setStateRequest] = useState(false)
   const [preOrderGroups, setPreOrderGroups] = useState([]);
   const [preOrderCombos, setPreOrderCombos] = useState([]);
   const [attachedFiles, setAttachedFiles] = useState([]);
   const [tables, setTables] = useState([]);
   const [zones, setZones] = useState([]);
   const [selectedTable, setSelectedTable] = useState(null);
   const [uploading, setUploading] = useState(false);
   const [showSimplePrintModal, setShowSimplePrintModal] = useState(false);
   const [datacreatePreOrder, setDataCreatePreOrder] = useState({});
   let title_modal = "Crear precuenta"
   let machine = JSON.parse(localStorage.getItem('machine'));
   let user = JSON.parse(localStorage.getItem('user'));
   let date = new Date().toJSON().slice(0, 10)

   const [branchOfficeData, setBranchofficeData] = useState({
      "ruc": "",
      "dv": "",
      "name": "",
      "ruc_type": "",
      "direction": "",
      "dgi_name": "",
   });

   const getPreOrderByid = async () => {
      let machine_token = localStorage.getItem('x-access-machine-token');
      if (dataPreOrder.pre_Order == true) {
         try {
            const response = await PreOrderFetchAPI.getPreOrderById(dataPreOrder._id, machine_token);
            setDataOrder(response.data.pre_order)
            if (response.data.pre_order.is_quote_order == true) {
               setFormType("quote")
            }
            setTableNumber(response.data.pre_order.table_name);
         } catch (err) {

         }
      }
   }

   // Función para manejar el cambio de archivos (máx 10 archivos, cada uno máx 5MB)
   const handleFileChange = (e) => {
      const MAX_FILES = 10;
      const MAX_SIZE_MB = 50;
      const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
      if (e.target.files && e.target.files.length > 0) {
         let files = Array.from(e.target.files);
         if (files.length > MAX_FILES) {
            AlertSmall(`Solo puedes adjuntar hasta ${MAX_FILES} archivos.`, 'warning');
            e.target.value = '';
            setAttachedFiles([]);
            return;
         }
         const oversized = files.find(file => file.size > MAX_SIZE_BYTES);
         if (oversized) {
            AlertSmall(`El archivo "${oversized.name}" excede el tamaño máximo de ${MAX_SIZE_MB}MB.`, 'warning');
            e.target.value = '';
            setAttachedFiles([]);
            return;
         }
         setAttachedFiles(files);
      }
   };

   // Función para guardar los archivos adjuntos
   const handleSaveFiles = async (order) => {
      if (!attachedFiles.length) return;
      setUploading(true);
      try {
         // State for client name, loaded from localStorage if available
         const formData = new FormData();
         attachedFiles.forEach((file, idx) => {
            formData.append('files', file);
         });
         formData.append('_id', order._id);
         // Aquí deberías llamar a tu API para subir los archivos
         let token = localStorage.getItem('x-access-machine-token');
         const response = await PreOrderFetchAPI.updateOrderTempPreOrderFile(formData, token);

         // await SomeAPI.uploadOrderAttachment(formData);
         AlertSmall('Archivos adjuntados correctamente', 'success');
         // State for client RUC (tax ID), loaded from localStorage if available
         setAttachedFiles([]);
      } catch (err) {
         showApiError(err, {
            title: "No se pudieron adjuntar los archivos",
            message: "Error al adjuntar archivos",
            context: `pre_order_id=${order?._id || ""}`,
         }, ErrorAlert);
      } finally {
         setUploading(false);
      }
   };

   const sendMail = (EmailData) => {
      // Gets a temporary order by code from the API
      let token = localStorage.getItem('x-access-machine-token')
      let data = EmailData


      try {
         const response = MailFetchAPI.sendMail(data, token)
         AlertSmall('Correo enviado con exito', 'success')

      } catch (err) {
         // Gets a temporary order by ID and navigates to the cart/order page
         showApiError(err, {
            title: "Error al enviar correo",
            message: "No se pudo enviar el correo",
         }, ErrorAlert);

      }
   }

   //Function to get a temporal order data by code
   const getTemporalOrderByCode = async (code) => {
      try {
         let token = localStorage.getItem('x-access-machine-token');
         let business = JSON.parse(localStorage.getItem('business'))
         let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
         const response = await OrdersFetchAPI.getTempOrderByCode(code, business.code, branchoffice.code, token);
         // Updates the pre-order with client data and note, sends email, and refreshes order data

         return response;
      } catch (err) {
         showApiError(err, {
            title: "No se pudo consultar la orden",
            message: "Error al consultar la orden temporal",
            context: `code=${code || ""}`,
         }, ErrorAlert);
      }
   }

   //get client by business 
   const getClientsByBusiness = async () => {
      let token = localStorage.getItem('x-access-machine-token');
      let business = JSON.parse(localStorage.getItem('business'))
      return new Promise(async (resolve, reject) => {
         try {

            let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
            let business_id = business.id
            if (parthner_order == true) {
               business_id = branchoffice.parthner_business
            }
            const response = await ClientsFetchAPI.getClientsByBusiness(business_id, token);
            resolve(response.data.data);
         } catch (err) {

            reject(err);
         }
      });
   }


   //function to authentication of ruc
   const authenticationDgi = async () => {
      let message = ""
      let title = ""
      let icon = ""
      if (ruc == "") {
         message = "No se ha ingresado ningun ruc."
         title = "Debes ingresar un ruc."
         icon = "warning"
         ErrorAlert(message, title, icon)
      } else {
         LoadingAlert()
         let token = localStorage.getItem('x-access-machine-token');
         let data = { ruc: ruc }
         try {
            const response = await AuthDgiFetchAPI.authenticationRuc(token, data)
            let dataDgi = response.data
            if (dataDgi.dgi_response.gResProc) {
               if (dataDgi.dgi_response.gResProc.dCodRes == "0680") {
                  let dvDgi = dataDgi.dgi_response.dDV
                  if (dvDgi.length < 2) { dvDgi = "0" + dvDgi }
                  setName(dataDgi.dgi_response.dNomb)
                  setDv(dvDgi)
                  message = "Datos del clientes obtenidos por la DGI"
                  title = "Datos obtenido correctamente"
                  icon = "success"
                  ErrorAlert(message, title, icon)
                  setDataResponse(true)
               } else {
                  setOptionalData(true)
                  message = "Ingrese los datos manualmente."
                  title = "Datos no encontrados"
                  icon = "warning"
                  ErrorAlert(message, title, icon)
               }
            }
         } catch (err) {

            setOptionalData(true)
            message = "Ingrese los datos manualmente."
            title = "Datos no encontrados"
            icon = "warning"
            ErrorAlert(message, title, icon)
         }
      }
   }

   const handlercreateValidation = () => {

      if (paramsMicros != 0) {
         if (paramsMicros.pos_integration_id == 2) {
            formatDataMicrosCheck(shoppingCart, shoppingCartCombos, "create")
         } else {
            createPreOrder()
         }
      } else {
         createPreOrder()
      }
   }


   const handlerUpdateValidation = () => {
      if (paramsMicros != 0) {
         if (paramsMicros.pos_integration_id == 2) {
            handlerComparativeNewData()
         } else {
            updatePreOrder()
         }
      } else {
         updatePreOrder()
      }
   }

   //create preOrder
   const createPreOrder = async (micros) => {
      if (stateRequest == false) {
         if (formType === "quote" && (!email || !phone)) {
            AlertSmall("Para cotización, nombre, correo y teléfono son obligatorios.", "warning")
         } else {
            setStateRequest(true)
            if ((shoppingCart.length + shoppingCartCombos.length) > 0) {
               LoadingAlert()
               let token = localStorage.getItem('x-access-machine-token');
               let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
               let machine = JSON.parse(localStorage.getItem('machine'))


               let json = {
                  "client_name": name,
                  "table_name": tableNumber,
                  "client_phone": dataClientSelected != null ? dataClientSelected.phone : "",
                  "ruc": ruc,
                  "dv": dv,
                  "id_Client": dataClientSelected != null ? dataClientSelected.id : 0,
                  "client_id": dataClientSelected != null ? dataClientSelected.id : 0,
                  "dgi_qr": "0",
                  "Orden": preOrderGroups,
                  "combos": preOrderCombos,
                  "Descuento": discount,
                  "Total": total,
                  "itbms": tax,
                  "subtotal": subtotal,
                  "machine_id": machine.id,
                  "branchoffice_id": branchoffice.id,
                  "tipoOrden": checkDeliveryOrder,
                  "paymethod": 0,
                  "localizador": 0,
                  "discounts": dataDicountApply,
                  "is_discount_notification": false,
                  "is_cupon": false,
                  "is_authorized": true,
                  "is_devolution_notification": false,
                  "taxes": taxesArrayAll,
                  "is_pre_order": true,
                  "user": {
                     id: user.id,
                     name: user.name,
                     code: user.user_code
                  },
                  "email_cc": [email_cc],
                  "aditional_info": aditional_data,
                  "client_address": addresDescriptionClientFiscal
               }

               if (eventDataState !== null) {
                  json.event_id = eventDataState.id
                  json.event_name = eventDataState.name;
               }

               if (events.length > 0 && selectedEvent != null) {
                  json.event_id = selectedEvent.id
               }

               if (formType == "quote") {
                  json.is_pre_order = false
                  json.is_quote_order = true
                  json.client_email = email
                  json.client_phone = phone
                  json.note = note
               }

               if (selectedTable != null) {
                  json.table_name = selectedTable.raw?.number || null
                  json.table_id = selectedTable?.value || null
                  json.table_code = selectedTable.raw?.code || null
               }

               if (micros != undefined) { json.micros_reference = micros.micros_reference }

               //We check if the user logged is a waiter to send the waiter info to the pre-order
               if (localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).role.find(r => r.name === "Mesero") != undefined) {
                  json.waiter = {
                     id: JSON.parse(localStorage.getItem("user")).id,
                     name: JSON.parse(localStorage.getItem("user")).name,
                     code: JSON.parse(localStorage.getItem("user")).user_code
                  }
               }


               try {
                  const response = await PreOrderFetchAPI.createPreOrder(json, token)
                  if (formType == "quote") {
                     const dataNewQuote = await getTemporalOrderByCode(response.data.newTempOrder.code);
                     let newdataOrder = dataNewQuote.data.order
                     handleSaveFiles(newdataOrder)
                     //let logo = localStorage.getItem("businessLogo")

                     let newShoppingCart = []
                     newdataOrder.groups.forEach(item => {
                        newShoppingCart.push({
                           ...item,
                           price: item.price.toFixed(2),
                           total: (item.price * item.amount).toFixed(2)
                        });
                     });

                     let dataEmailJson = {
                        "cc": newdataOrder.email_cc ? newdataOrder.email_cc : "",
                        "template": "quote_detaills",
                        "subject": "Cotizacion " + newdataOrder?.transaction_code + " Actualizada por el administrador",
                        "email": newdataOrder.client_email,
                        "emit": {
                           "name": branchoffice.fiscal_name,
                           "ruc": branchoffice.ruc,
                           "dv": branchoffice.dv
                        },
                        "branchoffice": {
                           "name": newdataOrder.branchoffice.name,
                        },
                        "business": {
                           "name": newdataOrder.business.name,
                        },
                        "client_name": newdataOrder.client_name,
                        "client_ruc": newdataOrder.client_ruc,
                        "client_dv": newdataOrder.client_dv,
                        "client_phone": newdataOrder.client_phone,
                        "code": newdataOrder.code,
                        "business_color": newdataOrder.business.color,
                        "discount_total": newdataOrder.discount.toFixed(2),
                        "footer_note": "Esta cotizacion es valida por 15 dias.",
                        "invoice_total": newdataOrder.total.toFixed(2),
                        "items": newShoppingCart,
                        "logo_url": logo,
                        "sub_total": newdataOrder.subtotal.toFixed(2),
                        "tax_total": newdataOrder.tax.toFixed(2),
                        "tips_total": newdataOrder.tips.toFixed(2),
                        "created_at": newdataOrder.createdAt,
                        "business_color": dataStyleBusiness?.layaoutColor ? dataStyleBusiness.layaoutColor : "#000000",
                        "buttonRedirect": "https://" + domainBusiness + ".ecommerce.smartpay.ai/order/quote/" + newdataOrder.code,
                        "note": newdataOrder.note ? newdataOrder.note : "",
                        "transaction_code": newdataOrder?.transaction_code,
                        "client_address": newdataOrder.client_address ? newdataOrder.client_address : "",
                        "aditional_info": newdataOrder.aditional_info ? newdataOrder.aditional_info : "",
                     }
                     sendMail(dataEmailJson);


                     setSelectedQuote(response.data.newTempOrder)
                     setShowQuoteDetails(true)
                  }
                  if (formType == "preOrder") {
                     setShowSimplePrintModal(true)
                     setDataCreatePreOrder({ id: response.data.newTempOrder._id, code: response.data.newTempOrder.code })
                     //printOrder(response.data.newTempOrder._id, response.data.newTempOrder.code)
                  } else {
                     localStorage.removeItem('client_data');
                     localStorage.removeItem('addressNowLocation');
                     setdataClientSelected(null);
                     setAddressNowLocation(null);
                     setTableNumber(0);
                     setPageLoader(1)
                  }
                  setFormType("preOrder")
                  setEmail_cc("")
                  setStateRequest(false)

                  setShow(false)
                  let message = "Precuenta creada con exito."
                  let title = "Operacion exitosa."
                  let icon = "success"
                  AlertSmall(message, icon)
               } catch (err) {
                  setStateRequest(false)
                  showApiError(err, {
                     title: formType == "quote" ? "No se pudo crear la cotizacion" : "No se pudo crear la precuenta",
                     message: "El servidor no pudo crear la precuenta.",
                     context: `branch=${branchoffice?.code || ""}`,
                  }, ErrorAlert);

               }
            } else {
               setStateRequest(false)
               ErrorAlert("Debes agregar  algo al carrito", "No hay productos en el carrito", "info")
            }
         }
      } else {

      }
   }



   //format data to send to micros
   const formatDataMicrosCheck = (groups, combos, action) => {
      //Json general format
      let jsonMicrosCheck = {
         RvcRef: paramsMicros.pos_integration_params.RvcRef,
         employeeNum: paramsMicros.pos_integration_params.employeeNum,
         host_url: paramsMicros.pos_integration_params.host_url,
         localMicrosServerIp: paramsMicros.pos_integration_params.localMicrosServerIp,
         products: [],
         automatic_payment: 0,
         delivery: false,
         client: { name: name, phone: "00" },
         paymentmethods: [{
            "name": "Credito",
            "paymenthod_id": 10,
            "total": total
         }],
      }

      if (action == "update") {
         let preOrderOld = JSON.parse(localStorage.getItem('preOrderComparativeOld'))
         jsonMicrosCheck.checkSeq = preOrderOld.micros_reference.checkSeq
         jsonMicrosCheck.checkNum = preOrderOld.micros_reference.checkNum
      }

      let data = []
      //json product format
      groups.forEach(product => {
         let dataDetail = {
            "code": product.group_id,
            "name": product.name,
            "price": product.price,
            "cant": product.amount,
            "tax": product.taxes[0].tax,
            "total_discount": product.discount,
            "exist_product": false,
            "total_product": product.price,
            "external_reference": product.external_reference,
            "type": "product",

         }

         let dataSegments = []


         product.segments.forEach(segment => {
            let detail = {
               "external_reference": segment.external_reference,
               "name": segment.name,
               "amount": segment.amount,
            }
            dataSegments.push(detail)
         })
         dataDetail.condiments = dataSegments
         data.push(dataDetail)
      });

      //----------------------------------------------
      //format combos
      combos.forEach(combo => {


         let dataDetailCombo = {
            "type": "combo",
            "code": combo.combo_id,
            "tax": combo.taxes[0].tax,
            "total_discount": combo.discount,
            "exist_product": false,
            "total_product": combo.price,
            "external_reference": combo.referenced_group.external_reference,
            "price": combo.price,
            "name": combo.name,
            "cant": combo.amount,
            "mainDetail": {},
            "sideDetails": [],
         }
         let setGroupsData = []
         combo.setGroups.forEach(setGroup => {

            setGroup.groups.forEach(group => {
               //json group format
               let dataDetail = {
                  "name": group.name,
                  "external_reference": group.external_reference,
                  "isMainProduct": false,
               }

               let dataSegments = []
               group.segments.forEach(segment => {
                  let detail = {
                     "external_reference": segment.external_reference,
                     "name": segment.name,
                     "amount": segment.amount,
                  }
                  dataSegments.push(detail)
               })
               //add data segments to group
               dataDetail.condiments = dataSegments

               if (setGroup.isMainSetGroup == 1) {
                  //add data to main detail
                  dataDetail.isMainProduct = true
                  dataDetailCombo.mainDetail = dataDetail
               } else {
                  //add data to side details
                  dataDetail.price = group.price
                  dataDetail.cant = group.amount
                  dataDetail.total = group.price
                  setGroupsData.push(dataDetail)
               }
            })
            //add data side details to combo
            dataDetailCombo.sideDetails = setGroupsData
         })
         //add combo to products
         data.push(dataDetailCombo)
      })
      jsonMicrosCheck.products = data
      createCheckMicrosOrderLocal(jsonMicrosCheck, action)
   }

   //request local to create open check in micros
   const createCheckMicrosOrderLocal = async (jsonMicrosCheck, action) => {
      let token = localStorage.getItem('x-access-machine-token');
      let type = "POST"
      if (action == "update") {
         type = "PUT"
      }
      let data = {
         Ruta: `http://${jsonMicrosCheck.localMicrosServerIp}:9472/api/micros/checks?RvcRef=${jsonMicrosCheck.RvcRef}&employeeNum=${jsonMicrosCheck.employeeNum}&host_url=${jsonMicrosCheck.host_url}`,
         Type: type,
         Header: { "x-access-token": token },
         Body: jsonMicrosCheck
      }




      let micros_response;
      try {
         micros_response = await RequestLocalFetchAPI.postMicros(data);


         //We validate if the micros response is success
         if (action == "create") {
            if (micros_response.data.micros_response.PostTransactionExResponse.pTotalsResponse.OperationalResult.ErrorCode._text !== undefined && micros_response.data.micros_response.PostTransactionExResponse.pTotalsResponse.OperationalResult.ErrorCode._text === "Success") {

               //We add the data that we want to update 
               let data_to_update = {
                  micros_reference: {
                     checkNum: micros_response.data.micros_response.PostTransactionExResponse.pGuestCheck.CheckNum._text,
                     checkSeq: micros_response.data.micros_response.PostTransactionExResponse.pGuestCheck.CheckSeq._text,
                  }
               }
               //We make the update of the order 
               createPreOrder(data_to_update)
            }
         } else if (action == "update") {
            updatePreOrder()
         }
      } catch (err) {

      }
   }

   //function action print order
   let arrayPrintersTemp = []

   const getPrinter = async () => {
      try {
         const response = await PrinterFetchAPI.getPrinter(localStorage.getItem('x-access-machine-token'), machine.id);

         let arrayPrinters = response.data.printers;
         let printer_Comanda = "";
         let printer_ticket = "";
         let printer_zebra = "";
         let printer_ip = "";
         for (let i = 0; i < arrayPrinters.length; i++) {
            getCategoriesByprinter(arrayPrinters[i])
            if (arrayPrinters[i].printer_type == 'Tickets') {
               printer_ticket = arrayPrinters[i].printer_name
               printer_ip = arrayPrinters[i].ip || ""
            } else if (arrayPrinters[i].printer_type == 'Comanda') {
               printer_Comanda = arrayPrinters[i].printer_name
            } else if (arrayPrinters[i].printer_type == 'Zebra') {
               printer_zebra = arrayPrinters[i].printer_name;
            }
         }

         setPrinters(arrayPrintersTemp)
         setInfoPrinter({ printer_comanda: printer_Comanda, printer_ticket: printer_ticket, printer_zebra: printer_zebra, printer_ip: printer_ip });

      } catch (err) {

      }
   }



   const getCategoriesByprinter = async (printer) => {

      try {
         const response = await CategriesPosFetchAPI.getCategoriesByPrinters(printer.printer_id, localStorage.getItem('x-access-machine-token'))
         printer.categories = response.data.categories

      } catch (err) {
         printer.categories = []

      }
      arrayPrintersTemp.push(printer)

   }

   //print order
   const printOrder = async (id_Orden_Imprimir, transaction_code, onlyComanda) => {
      let ip_print = "localhost"
      const isUpdatingExistingPreOrder = Boolean(dataPreOrder?._id || selectPreOrder?._id);
      const hasKitchenItemsToPrint = hasPreOrderKitchenItemsToPrint(preOrderGroups, preOrderCombos, {
         printUnmarkedItems: !isUpdatingExistingPreOrder,
      });

      if (localStorage.getItem("ip_printer") != "" && localStorage.getItem("ip_printer") != undefined && localStorage.getItem("ip_printer") != null) {
         ip_print = localStorage.getItem("ip_printer")
      }

      let dataPrinters = printers
      if (onlyComanda == true) {
         if (!hasKitchenItemsToPrint) {
            AlertSmall("No hay productos pendientes para enviar a cocina", "info")
            return;
         }
         dataPrinters = printers.filter(printer => printer.printer_type === "Comanda")
      } else if (!hasKitchenItemsToPrint) {
         dataPrinters = printers.filter(printer => printer.printer_type === "Tickets")
      }

      let JsonImprimir = [{
         "type_ticket": "precuenta",
         "table_name": tableNumber,
         "Printers": dataPrinters,
         "Nombre_maquina_impresora": infoPrinter.printer_ticket,
         "Nombre_cocina_impresora": infoPrinter.printer_comanda,
         "Nombre_zebra_impresora": infoPrinter.printer_zebra,
         "PRINTER_IP": infoPrinter.printer_ip,
         "Id_Orden_Imprimir": id_Orden_Imprimir,
         "token": localStorage.getItem('x-access-machine-token'),
         "transaction_code": transaction_code,
         "amount_item": shoppingCart.length,
         "imprimir_comanda": hasKitchenItemsToPrint ? "si" : "no",
      }]


      printOrderData(JsonImprimir);
      localStorage.removeItem('client_data');
      localStorage.removeItem('addressNowLocation');
      setdataClientSelected(null);
      setAddressNowLocation(null);
      setTableNumber(0);
      setPageLoader(1)

      try {
         const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));

         if (ip_print == "localhost") {
            const response = await PrinterFetchAPI.printOrder(ip_print, JsonImprimir, response_machine.data.data.windows_ip)
         } else {
            const response = await PrinterFetchAPI.printByServerMiddle(ip_print, JsonImprimir)
         }


         AlertSmall("Orden enviada a imprimir", "success")

      } catch (err) {

      }
   }

   // view get order to return
   const cardGetOrder = () => {
      const cardOrder = preOrderGroups.map((product, index) => (
         <div key={index}>
            {product.type == "separator" ? (
               <div className="qmdl-sep">{product.name}</div>
            ) : (
               <article className="qmdl-item">
                  <img
                     className="qmdl-item-img"
                     loading="lazy"
                     src={buildCloudinaryImageUrl({ url: product.img, type: "image", width: 300, quality: "auto" }) || defaultImage}
                     alt=""
                  />

                  <div className="qmdl-item-body">
                     <div className="qmdl-item-head">
                        <span className="qmdl-item-name">{product.name}</span>
                        <span className="qmdl-item-price" translate="no">${product.price.toFixed(2)}</span>
                     </div>

                     <details className="qmdl-item-details" open>
                        <summary>Detalles</summary>
                        <ul className="qmdl-segs">
                           {product.segments.map((item, idx) => (
                              <li key={idx}>
                                 <span className="qmdl-seg-key">{item.segment_name}: {item.name}</span>
                                 <span className="qmdl-seg-val" translate="no">${Number(item.price).toFixed(2)}</span>
                              </li>
                           ))}
                        </ul>
                     </details>

                     {/* Switch kitchen_action */}
                     {selectPreOrder?.is_quote_order == true || formType == "quote" || formType == "" ? <></> : <>
                        {dataPreOrder.pre_Order && dataPreOrder.pre_Order == true && product.kitchen_action === 'send_to_kitchen' ? <>
                           {product?.isNewAdd == true ? (
                              <div className="qmdl-item-switch">
                                 <Form.Check
                                    type="switch"
                                    id={`kitchen-switch-group-${index}`}
                                    label={
                                       product.kitchen_action === 'send_to_kitchen'
                                          ? 'Enviar a cocina'
                                          : 'Mantener en espera'
                                    }
                                    checked={product.kitchen_action === 'send_to_kitchen'}
                                    onChange={(e) =>
                                       handleToggleKitchenActionGroup(index, e.target.checked)
                                    }
                                 />
                              </div>
                           ) : (
                              <span className="qmdl-item-sent">Enviado a cocina</span>
                           )}
                        </> : (
                           <div className="qmdl-item-switch">
                              <Form.Check
                                 type="switch"
                                 id={`kitchen-switch-group-${index}`}
                                 label={
                                    product.kitchen_action === 'send_to_kitchen'
                                       ? 'Enviar a cocina'
                                       : 'Mantener en espera'
                                 }
                                 checked={product.kitchen_action === 'send_to_kitchen'}
                                 onChange={(e) =>
                                    handleToggleKitchenActionGroup(index, e.target.checked)
                                 }
                              />
                           </div>
                        )}
                     </>}
                  </div>
               </article>
            )}
         </div>
      ));
      return (cardOrder)
   }

   // view get order to return
   const cardGetOrderCombo = () => {
      const cardOrder = preOrderCombos.map((product, index) => (
         <article className="qmdl-item" key={index}>
            <img
               className="qmdl-item-img"
               loading="lazy"
               src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage}
               alt=""
            />

            <div className="qmdl-item-body">
               <div className="qmdl-item-head">
                  <span className="qmdl-item-name">{product.name}</span>
                  <span className="qmdl-item-price" translate="no">${product.price.toFixed(2)}</span>
               </div>

               {product.setGroups.map((setGroup) => (
                  <details className="qmdl-item-details" key={setGroup.set_id}>
                     <summary>{setGroup.name}</summary>
                     {setGroup.groups.map((group) => (<>
                        {cardGroup(group)}
                     </>))}
                  </details>
               ))}

               {/* Switch kitchen_action for combo */}
               <div className="qmdl-item-switch">
                  <Form.Check
                     type="switch"
                     id={`kitchen-switch-combo-${index}`}
                     label={
                        product.kitchen_action === 'send_to_kitchen'
                           ? 'Enviar a cocina'
                           : 'Mantener en espera'
                     }
                     checked={product.kitchen_action === 'send_to_kitchen'}
                     onChange={(e) =>
                        handleToggleKitchenActionCombo(index, e.target.checked)
                     }
                  />
               </div>
            </div>
         </article>
      ));
      return (cardOrder)
   }


   // update pre order
   const updatePreOrder = async (micros) => {
      if (stateRequest == false) {
         setStateRequest(true)
         let token = localStorage.getItem('x-access-machine-token');
         let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))

         let dataEmial_cc = selectPreOrder.email_cc ? selectPreOrder.email_cc : []
         if (email_cc && email_cc != "") {
            dataEmial_cc.push(email_cc)
         }
         let json = {
            "client_name": name,
            "localizador": "00",
            "table_name": tableNumber,
            "ruc": ruc,
            "dv": dv,
            "is_discount_notification": false,
            "_id": dataPreOrder._id,
            "order_type": checkDeliveryOrder,
            "groups": preOrderGroups,
            "combos": preOrderCombos,
            "discounts": dataDicountApply,
            "taxes": taxesArrayAll,
            "discount": discount,
            "is_authorized": true,
            "total": total,
            "tax": tax,
            "subtotal": subtotal,
            "note": note,
            "removed_products": removedPreOrderShoppingCartProducts,
            "email_cc": dataEmial_cc,
            "aditional_info": aditional_data,
            "client_address": addresDescriptionClientFiscal
         }

         if (micros != undefined) { json.micros_reference = micros.micros_reference }

         try {
            const response = await PreOrderFetchAPI.updateOrderTempPreOrder(json, token)
            setStateRequest(false)


            if (selectPreOrder?.is_quote_order == true) {
               const dataNewQuote = await getTemporalOrderByCode(selectPreOrder.code);
               let newdataOrder = dataNewQuote.data.order
               let logo = localStorage.getItem("businessLogo")



               let newShoppingCart = []

               newdataOrder.groups.forEach(item => {
                  newShoppingCart.push({
                     ...item,
                     price: item.price.toFixed(2),
                     total: (item.price * item.amount).toFixed(2)
                  });
               });

               let dataEmailJson = {
                  "cc": dataEmial_cc,
                  "template": "quote_detaills",
                  "subject": "Cotizacion " + newdataOrder?.transaction_code + " Actualizada por el administrador",
                  "email": newdataOrder.client_email,
                  "emit": {
                     "name": branchoffice.fiscal_name,
                     "ruc": branchoffice.ruc,
                     "dv": branchoffice.dv

                  },
                  "branchoffice": {
                     "name": newdataOrder.branchoffice.name,
                  },
                  "business": {
                     "name": newdataOrder.business.name,
                  },
                  "client_name": newdataOrder.client_name,
                  "client_ruc": newdataOrder.client_ruc,
                  "client_dv": newdataOrder.client_dv,
                  "client_phone": newdataOrder.client_phone,
                  "code": newdataOrder.code,
                  "business_color": newdataOrder.business.color,
                  "discount_total": newdataOrder.discount.toFixed(2),
                  "footer_note": "Esta cotizacion es valida por 15 dias.",
                  "invoice_total": newdataOrder.total.toFixed(2),
                  "items": newShoppingCart,
                  "logo_url": logo,
                  "sub_total": newdataOrder.subtotal.toFixed(2),
                  "tax_total": newdataOrder.tax.toFixed(2),
                  "tips_total": newdataOrder.tips.toFixed(2),
                  "created_at": newdataOrder.createdAt,
                  "business_color": dataStyleBusiness?.layaoutColor ? dataStyleBusiness.layaoutColor : "#000000",
                  "buttonRedirect": "https://" + domain + "/order/quote/" + newdataOrder.code,
                  "note": newdataOrder.note ? newdataOrder.note : "",
                  "transaction_code": newdataOrder?.transaction_code,
                  "client_address": newdataOrder.client_address ? newdataOrder.client_address : "",
                  "aditional_info": newdataOrder.aditional_info ? newdataOrder.aditional_info : "",
               }
               sendMail(dataEmailJson);
            }

            if (micros != undefined) {

            } else {
               if (formType == "preOrder") {
                  //printOrder(response.data._id, response.data.code)
                  setShowSimplePrintModal(true)
                  setDataCreatePreOrder({ id: response.data._id, code: response.data.code })

               }

               setShow(false)
               /* let message = "Precuenta actualizada con exito."
                let title = "Operacion exitosa"
                let icon = "success"
                setPageLoader(1)
                ErrorAlert(message, title, icon)*/
            }

            setFormType("preOrder")
            setEmail_cc("")

         } catch (err) {
            setStateRequest(false)
            showApiError(err, {
               title: selectPreOrder?.is_quote_order == true ? "No se pudo actualizar la cotizacion" : "No se pudo actualizar la precuenta",
               message: "El servidor no pudo actualizar la precuenta.",
               context: `pre_order_id=${dataPreOrder?._id || ""}`,
            }, ErrorAlert);

         }

      } else {

      }
   }

   const handlerChangeDataOrder = () => {


      if (dataPreOrder.pre_Order == true) {
         getPreOrderByid()
      }
      ErrorAlert("", "Nombre guardado", "success")
   }

   /* ============================================================
      Totales: se declaran una vez y viven en el popup.
   ============================================================ */
   const quoteTotalsLines = (
      <>
         <div className="qmdl-line">
            <span>Descuento</span>
            <span className="qmdl-line-val" translate="no">${discount.toFixed(2)}</span>
         </div>

         <div className="qmdl-line">
            <span>Subtotal</span>
            <span className="qmdl-line-val" translate="no">${subtotal.toFixed(2)}</span>
         </div>

         <div className="qmdl-line">
            <span>Impuestos</span>
            <span className="qmdl-line-val" translate="no">${tax.toFixed(2)}</span>
         </div>

         <div className="qmdl-line qmdl-line--total">
            <span>Total <small>incluye impuestos</small></span>
            <span className="qmdl-line-val" translate="no">${total.toFixed(2)}</span>
         </div>
      </>
   );

   const viewFormPreOrderAndQuote = () => {
      return (
         <div className="qmdl-form-inner">

            <div className="qmdl-form-head">
               <h3 className="qmdl-card-title">Datos del cliente</h3>
               {selectPreOrder?.is_quote_order == true ? <></> : (
                  <button
                     type="button"
                     className="qmdl-switch-type"
                     onClick={() => { setFormType(formType == "preOrder" ? "quote" : "preOrder") }}
                  >
                     {formType == "preOrder"
                        ? <><i className="uil uil-clipboard-alt" /> Cambiar a cotización</>
                        : <><i className="uil uil-invoice" /> Cambiar a precuenta</>}
                  </button>
               )}
            </div>

            <ClientPillCard dataClientSelected={dataClientSelected} setdataClientSelected={setdataClientSelected} addressNowLocation={addressNowLocation} setAddressNowLocation={setAddressNowLocation} parthner_order={parthner_order} setShoppingCart={setShoppingCart} calculateInvoiceTotals={calculateInvoiceTotals} enabledOnlineOrder={enabledOnlineOrder} parthners={parthners} selectRestaurant={selectRestaurant} setResetData={setResetData} shoppingCart={shoppingCart} shoppingCartCombos={shoppingCartCombos} setShoppingCartCombos={setShoppingCartCombos} />

            {eventsAndDates()}

            {formType == "preOrder" ? <>

               <div className="qmdl-field-row">
                  <div className="qmdl-field">
                     <label className="qmdl-label" htmlFor="qmdl-account">Nombre de la cuenta</label>
                     <input
                        id="qmdl-account"
                        type="text"
                        className="qmdl-input"
                        value={name || ''}
                        onChange={e => setName(e.target.value)}
                        placeholder="Nombre de la cuenta"
                     />
                  </div>

                  <div className="qmdl-field">
                     <span className="qmdl-label">Fecha</span>
                     <div className="qmdl-readonly">{date}</div>
                  </div>
               </div>

               {selectPreOrder?.is_quote_order === true ? <></> : (
                  <div className="qmdl-field">
                     <label className="qmdl-label">Mesa</label>
                     <Select
                        value={selectedTable}
                        onChange={(opt) => { setSelectedTable(opt); setTableNumber(opt?.raw?.number) }}
                        options={tableOptions}
                        isClearable
                        placeholder="Buscar mesa/stand..."
                        noOptionsMessage={() => "No hay mesas que coincidan"}
                        classNamePrefix="qmdl-select"
                     />
                  </div>
               )}

               <details className="qmdl-details">
                  <summary><i className="uil uil-edit" /> Editar nombre</summary>
                  <div className="qmdl-field">
                     <label className="qmdl-label" htmlFor="qmdl-name-2">Ingresa un nombre</label>
                     <input
                        id="qmdl-name-2"
                        className="qmdl-input"
                        placeholder={name}
                        onChange={(e) => (setName(e.target.value))}
                     />
                  </div>
               </details>

            </> : <>

               <div className="qmdl-field">
                  <label className="qmdl-label" htmlFor="qmdl-fullname">
                     <i className="uil uil-user-circle" /> Nombre completo
                  </label>
                  <input
                     id="qmdl-fullname"
                     type="text"
                     value={name || ''}
                     className={`qmdl-input${!name || name.trim() === '' ? ' is-invalid' : ''}`}
                     placeholder="Ingresa tu nombre completo"
                     onChange={(e) => setName(e.target.value)}
                     required
                  />
                  {(!name || name.trim() === '') && (
                     <small className="qmdl-error">Este campo es obligatorio</small>
                  )}
               </div>

               <div className="qmdl-field">
                  <label className="qmdl-label" htmlFor="qmdl-email">
                     <i className="uil uil-envelope" /> Correo electrónico
                  </label>
                  <input
                     id="qmdl-email"
                     type="email"
                     className={`qmdl-input${!email || email.trim() === '' ? ' is-invalid' : ''}`}
                     placeholder="ejemplo@correo.com"
                     value={email || ''}
                     onChange={(e) => setEmail(e.target.value)}
                     required
                  />
                  {(!email || email.trim() === '') && (
                     <small className="qmdl-error">Este campo es obligatorio</small>
                  )}
               </div>

               <div className="qmdl-field">
                  <label className="qmdl-label">
                     <i className="uil uil-phone-alt" /> Teléfono
                  </label>
                  <PhoneInput
                     country={'pa'}
                     value={phone || ''}
                     onChange={phone => (setPhone(phone))}
                     inputProps={{
                        name: 'phone2',
                        required: true,
                        autoFocus: true
                     }}
                     countryCodeEditable={false}
                     enableSearch
                     inputStyle={!phone || phone.trim() === '' ? { borderColor: '#dc3545' } : {}}
                  />
                  {(!phone || phone.trim() === '') && (
                     <small className="qmdl-error">Este campo es obligatorio</small>
                  )}
               </div>

               <div className="qmdl-field">
                  <label className="qmdl-label" htmlFor="qmdl-email-cc">
                     <i className="uil uil-envelope-add" /> Correo cc <span className="qmdl-optional">opcional</span>
                  </label>
                  <input
                     id="qmdl-email-cc"
                     type="email_cc"
                     className="qmdl-input"
                     placeholder="ejemplo@correo.com"
                     value={email_cc || ''}
                     onChange={(e) => setEmail_cc(e.target.value)}
                     required
                  />
               </div>

               <details className="qmdl-details">
                  <summary>Información adicional</summary>

                  <div className="qmdl-field">
                     <label className="qmdl-label" htmlFor="qmdl-address">Dirección fiscal</label>
                     <input
                        id="qmdl-address"
                        className="qmdl-input"
                        placeholder="Ejemplo: calle, número, corregimiento"
                        value={addresDescriptionClientFiscal}
                        maxLength={90}
                        onChange={(e) => (setAddresDescriptionClientFiscal(e.target.value))}
                     />
                  </div>

                  <div className="qmdl-field">
                     <label className="qmdl-label" htmlFor="qmdl-extra">Dato adicional</label>
                     <textarea
                        id="qmdl-extra"
                        className="qmdl-input qmdl-textarea"
                        rows="3"
                        placeholder="Orden de compra, dirección…"
                        value={aditional_data}
                        onChange={(e) => (setAditional_data(e.target.value))}
                     />
                  </div>

                  {/* Input para adjuntar archivos */}
                  {selectPreOrder.files && selectPreOrder.files.length > 0 ? <></> : <>
                     <div className="qmdl-field">
                        <label className="qmdl-label" htmlFor="qmdl-files">
                           <i className="uil uil-paperclip" /> Adjuntar archivos <span className="qmdl-optional">opcional</span>
                        </label>
                        <input
                           id="qmdl-files"
                           type="file"
                           className="qmdl-input qmdl-file"
                           onChange={handleFileChange}
                           accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.txt"
                           multiple
                           max={10}
                        />
                        {attachedFiles.length > 0 && (
                           <ul className="qmdl-files">
                              {attachedFiles.map((file, idx) => (
                                 <li key={idx}><i className="uil uil-file" /> {file.name}</li>
                              ))}
                           </ul>
                        )}
                     </div>
                  </>}
               </details>

               <details className="qmdl-details">
                  <summary><i className="uil uil-edit" /> RUC / DV</summary>

                  <div className="qmdl-field-row">
                     <div className="qmdl-field">
                        <label className="qmdl-label" htmlFor="qmdl-ruc">Número de RUC</label>
                        <input
                           id="qmdl-ruc"
                           type="text"
                           className="qmdl-input"
                           placeholder="0-0000-0"
                           value={ruc}
                           onChange={(e) => setRuc(e.target.value)}
                        />
                     </div>

                     <div className="qmdl-field">
                        <label className="qmdl-label" htmlFor="qmdl-dv">Número DV</label>
                        <input
                           id="qmdl-dv"
                           type="number"
                           className="qmdl-input"
                           placeholder="00"
                           value={dv}
                           onChange={(e) => setDv(e.target.value)}
                        />
                     </div>
                  </div>

                  <button
                     className="qmdl-btn qmdl-btn--ghost qmdl-btn--block"
                     type="button"
                     onClick={authenticationDgi}
                     title="Validar RUC"
                  >
                     Validar RUC
                  </button>
               </details>

            </>}

            {selectPreOrder?.is_quote_order == true || formType == "quote" ? (
               <div className="qmdl-field">
                  <label className="qmdl-label" htmlFor="qmdl-note">Notas</label>
                  <textarea
                     id="qmdl-note"
                     className="qmdl-input qmdl-textarea"
                     rows="3"
                     value={note}
                     onChange={(e) => (setNote(e.target.value))}
                     placeholder="Escribir..."
                  />
               </div>
            ) : null}

         </div>
      )
   }


   //function to compare data micros and update
   const handlerComparativeNewData = () => {
      let preOrderComparativeOld = JSON.parse(localStorage.getItem('preOrderComparativeOld'))
      let OrderGroupsOld = preOrderComparativeOld.groups
      let OrderCombosOld = preOrderComparativeOld.combos
      let newGroups = []
      let newCombos = []

      //comparative groups
      shoppingCart.forEach(group => {
         let groupOld = OrderGroupsOld.find(item => item.group_id == group.group_id && item.segments_string == group.segments_string)

         if (groupOld != undefined) {
            if (groupOld.amount != group.amount) {
               let newGroup = groupOld
               newGroup.amount = (group.amount - groupOld.amount)
               newGroup.cantidadItem = (group.amount - groupOld.amount)
               newGroups.push(newGroup)
            }
         } else {
            newGroups.push(group)
         }
      });

      //Add string data to compare
      shoppingCartCombos.forEach(combo => {
         let stringdata = combo.combo_id + "";
         combo.setGroups.forEach(setGroup => {
            stringdata += setGroup.set_id;
            setGroup.groups.forEach(group => {
               stringdata += group.group_id;
               group.segments.forEach(segment => {
                  stringdata += segment.segment_id + segment.item.item_id;
               });
            });
         });
         combo.combo_string = stringdata;
      });

      //Add string data to compare
      OrderCombosOld.forEach(comboOld => {
         let stringdataOld = comboOld.combo_id + "";
         comboOld.setGroups.forEach(setGroup => {
            stringdataOld += setGroup.set_id;
            setGroup.groups.forEach(group => {
               stringdataOld += group.group_id;
               group.segments.forEach(segment => {
                  stringdataOld += segment.segment_id + segment.item.item_id;
               });
            });
         });
         comboOld.combo_string = stringdataOld;
      });

      //==========================================
      //Comparative combos
      shoppingCartCombos.forEach(combo => {
         let comboOld = OrderCombosOld.find(comboOld => comboOld.combo_id == combo.combo_id && comboOld.combo_string == combo.combo_string)

         if (comboOld != undefined) {
            if (comboOld.amount != combo.amount) {
               let newCombo = comboOld
               newCombo.amount = (combo.amount - comboOld.amount)
               newCombo.cantidadItem = (combo.amount - comboOld.amount)
               newCombos.push(newCombo)
            }
         } else {
            newCombos.push(combo)
         }
      });

      formatDataMicrosCheck(newGroups, newCombos, "update")
   }

   // Toggle kitchen_action for single product (group)
   const handleToggleKitchenActionGroup = (index, isChecked) => {
      setPreOrderGroups(prev =>
         prev.map((p, i) =>
            i !== index ? p : {
               ...p,
               kitchen_action: isChecked ? 'send_to_kitchen' : 'hold',
               isNewAdd: isChecked,
               amount_to_impress: isChecked ? Number(p.amount_to_impress || p.amount || 1) : 0,
            }
         )
      );
   };

   // Toggle kitchen_action for combos
   const handleToggleKitchenActionCombo = (index, isChecked) => {
      setPreOrderCombos(prev =>
         prev.map((c, i) =>
            i !== index ? c : {
               ...c,
               kitchen_action: isChecked ? 'send_to_kitchen' : 'hold',
               isNewAdd: isChecked,
               amount_to_impress: isChecked ? Number(c.amount_to_impress || c.amount || 1) : 0,
            }
         )
      );
   };


   // ====== CRUD branchoffice tables ======
   const getBranchofficeTables = async () => {
      try {
         let response = await TablesFetchAPI.getBranchofficeTables(branchoffice?.id, token);
         // We set the tables
         setTables(response.data.tables.map(table => ({
            id: table.id,
            number: table.name,
            code: table.code,
            zone: table.branchoffice_environment_id,
         })));
      } catch (e) {
         setTables([]);
      }
   };


   // options for the table select using  react-select
   const tableOptions = useMemo(() => {
      return (tables || []).map(t => ({
         value: t.id,
         label: `${t.name ?? `Mesa ${t.number ?? t.code ?? t.id}`}${t.environment_name ? ` • ${t.environment_name}` : ""}`,
         raw: t, // We keep the raw table data for later use when a table is selected
      }));
   }, [tables]);


   useEffect(() => {
      setEmail(dataClientSelected?.email)
      setPhone(dataClientSelected?.phone)
   }, [dataClientSelected])

   useEffect(() => {
      if (show) {
         // Clone groups with default kitchen_action
         const groupsWithKitchen = shoppingCart.map(p => ({
            ...p,
            kitchen_action: p.kitchen_action || 'send_to_kitchen'
         }));

         // Clone combos with default kitchen_action
         const combosWithKitchen = shoppingCartCombos.map(c => ({
            ...c,
            kitchen_action: c.kitchen_action || 'send_to_kitchen'
         }));

         setPreOrderGroups(groupsWithKitchen);
         setPreOrderCombos(combosWithKitchen);
      }
   }, [show, shoppingCart, shoppingCartCombos]);

   useEffect(() => {
      if (!show) return;

      //  API calls
      getBranchofficeTables();

      // Reset selection when opening
      setSelectedTable("");
   }, [show]);


   useEffect(() => {
      setNote(selectPreOrder?.note || "");
      setEmail(selectPreOrder?.client_email || "");
      setPhone(selectPreOrder?.client_phone || "");
      if (selectPreOrder?.is_quote_order == true) { setFormType("quote") } else {
         setFormType("preOrder")
      }
   }, [selectPreOrder])



   useEffect(() => {
      (async () => {


         try {
            let business = ''
            let token = ''
            let branchoffice = ''
            if (localStorage.getItem("branchoffice") !== "" || localStorage.getItem("branchoffice") !== null || localStorage.getItem("branchoffice") !== undefined) {

               business = JSON.parse(localStorage.getItem("business"))
               branchoffice = JSON.parse(localStorage.getItem("branchoffice"))

            }

            //We get the branchoffice info 
            const response_branch = await BranchOfficeFetchAPI.getBranchOfficeByCode(business.code, branchoffice.code);
            //We set the business data 
            setBranchofficeData(response_branch.data.branchoffice);

         } catch (err) {
            setBranchofficeData({
               "ruc": "",
               "dv": "",
               "name": "",
               "ruc_type": "",
               "direction": "",
               "dgi_name": "",
            })
         }
      })();
   }, []);

   useEffect(() => {
      if (!show) return;
      const onKey = (e) => {
         if (e.key !== "Escape") return;
         setShow(false); setFormType("preOrder"); setAttachedFiles([]); setEmail_cc("");
      };
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      document.addEventListener("keydown", onKey);
      return () => {
         document.body.style.overflow = prev;
         document.removeEventListener("keydown", onKey);
      };
   }, [show]);

   return (
      <>

         <button className='btn-pre-order px-2 py-1 btn btn-outline-light-secondary   rounded-3 btn-sm'
            onClick={() => (setShow(true), getPrinter(), getPreOrderByid())}>
            <small className='fw-bold buttons-label ' >
               <i className="uil uil-receipt"></i>
               <span className='fw-bold d-none d-lg-inline'>{dataPreOrder.pre_Order && dataPreOrder.pre_Order == true
                  ? <> Actualizar{selectPreOrder?.is_quote_order == true ? <> Cotizacion</> : <> precuenta</>}</>

                  : <> Crear Precuenta</>}</span>
            </small>
         </button>

         {show && createPortal(
            <div className="qmdl-overlay" role="dialog" aria-modal="true" aria-label="Precuenta o cotización">
               <div className="qmdl-dialog">

                  {/* ---------------- HEADER ---------------- */}
                  <header className="qmdl-head">
                     <i className="uil uil-receipt" />
                     <h2 className="qmdl-title">
                        {dataPreOrder.pre_Order && dataPreOrder.pre_Order == true
                           ? <>Actualizar{selectPreOrder?.is_quote_order == true ? <> cotización</> : <> precuenta</>}</>
                           : <>{formType == "preOrder" ? <>Crear precuenta</> : <>{formType == "" ? <>Selecciona una acción</> : <>Crear cotización</>}</>}</>}
                     </h2>
                     <button
                        type="button"
                        className="qmdl-close"
                        aria-label="Cerrar"
                        onClick={() => (setShow(false), setFormType("preOrder"), setAttachedFiles([]), setEmail_cc(""))}
                     >
                        <i className="uil uil-times" />
                     </button>
                  </header>

                  {/* ---------------- BODY ---------------- */}
                  <div className="qmdl-body">
                     <div className="qmdl-grid">

                        {/* ===== COLUMNA IZQUIERDA: tipo y formulario ===== */}
                        <section className="qmdl-card qmdl-card--form">
                           {!formType && (
                              <div className="qmdl-choice">
                                 <p className="qmdl-choice-text">¿Qué deseas crear?</p>

                                 <div className="qmdl-choice-grid">
                                    <button
                                       type="button"
                                       className="qmdl-type"
                                       onClick={() => setFormType('preOrder')}
                                    >
                                       <i className="uil uil-file-alt" />
                                       <span>Precuenta</span>
                                    </button>

                                    <button
                                       type="button"
                                       className="qmdl-type"
                                       onClick={() => setFormType('quote')}
                                    >
                                       <i className="uil uil-file-copy-alt" />
                                       <span>Cotización</span>
                                    </button>
                                 </div>
                              </div>
                           )}

                           {(formType === 'preOrder' || formType === 'quote') && (
                              <div className="qmdl-form">
                                 {formType === 'preOrder' && (
                                    <>{viewFormPreOrderAndQuote && viewFormPreOrderAndQuote('precuenta')}</>
                                 )}
                                 {formType === 'quote' && (
                                    <>{viewFormPreOrderAndQuote && viewFormPreOrderAndQuote('cotizacion')}</>
                                 )}
                              </div>
                           )}
                        </section>

                        {/* ===== COLUMNA DERECHA: productos ===== */}
                        <section className="qmdl-card qmdl-card--list">
                           <h3 className="qmdl-card-title">Productos incluidos</h3>
                           <div className="qmdl-list">
                              {cardGetOrder()}
                              {cardGetOrderCombo()}
                           </div>
                        </section>

                     </div>
                  </div>

                  {/* ---------------- FOOTER ---------------- */}
                  <div className="qmdl-foot">
                     <div className="qmdl-foot-total">
                        <span className="qmdl-foot-text">
                           <span className="qmdl-foot-label">Total</span>
                           <span className="qmdl-foot-amount" translate="no">${total.toFixed(2)}</span>
                        </span>

                        <button
                           type="button"
                           className="qmdl-summary-btn"
                           onClick={() => setShowTotals(true)}
                        >
                           <i className="uil uil-receipt" /> Ver totales
                        </button>
                     </div>

                     <div className="qmdl-foot-actions">
                        <button
                           className="qmdl-btn qmdl-btn--ghost"
                           onClick={() => (setShow(false), setFormType("preOrder"), setAttachedFiles([]), setEmail_cc(""))}
                        >
                           Cancelar
                        </button>

                        {dataPreOrder.pre_Order && dataPreOrder.pre_Order == true ? (
                           <button
                              className="qmdl-btn qmdl-btn--update"
                              onClick={async () => (handlerUpdateValidation())}
                           >
                              Actualizar{selectPreOrder?.is_quote_order == true ? <> cotización</> : <> precuenta</>}
                           </button>
                        ) : (
                           formType == "" ? <></> : (
                              <button
                                 className="qmdl-btn qmdl-btn--create"
                                 onClick={() => (handlercreateValidation())}
                              >
                                 {formType == "preOrder" ? <>Crear precuenta</> : <>Crear cotización</>}
                              </button>
                           )
                        )}
                     </div>
                  </div>

                  {/* ---------------- POPUP DE TOTALES ---------------- */}
                  <PaySheet
                     open={showTotals}
                     title="Totales"
                     onClose={() => setShowTotals(false)}
                  >
                     {quoteTotalsLines}
                  </PaySheet>

               </div>
            </div>,
            document.body
         )}


         {/* CONFIRMACIÓN DE IMPRESIÓN */}
         {showSimplePrintModal && createPortal(
            <div className="qmdl-confirm-overlay" role="dialog" aria-modal="true" aria-label="Imprimir cuenta">
               <div className="qmdl-confirm" onClick={(e) => e.stopPropagation()}>
                  <div className="qmdl-confirm-icon" aria-hidden="true">
                     <i className="uil uil-print" />
                  </div>
                  <h3 className="qmdl-confirm-title">¿Imprimir esta cuenta?</h3>
                  <p className="qmdl-confirm-text">
                     Si eliges no imprimir, la comanda de cocina se envía igual.
                  </p>

                  <div className="qmdl-confirm-actions">
                     <button
                        className="qmdl-btn qmdl-btn--ghost"
                        onClick={() => (printOrder(datacreatePreOrder.id, datacreatePreOrder.code, true), setShowSimplePrintModal(false))}
                     >
                        No
                     </button>
                     <button
                        className="qmdl-btn qmdl-btn--update"
                        onClick={() => (printOrder(datacreatePreOrder.id, datacreatePreOrder.code), setShowSimplePrintModal(false))}
                     >
                        Sí, imprimir
                     </button>
                  </div>
               </div>
            </div>,
            document.body
         )}


         {/* MODAL DETALLES DE COTIZACIÓN */}
         <ModalQuoteDetails
            show={showQuoteDetails}
            onClose={() => setShowQuoteDetails(false)}
            quote={selectedQuote}
            branchOfficeData={branchOfficeData}
            logo={logo}
            onShare={() => {
               if (selectedQuote) {
                  // Aquí puedes implementar la lógica de compartir (copiar link, abrir modal, etc)
                  navigator.clipboard.writeText(`https://${domainBusiness}.ecommerce.smartpay.ai/order/quote/${selectedQuote.code}`);
                  Swal.fire('¡Enlace copiado!', 'El enlace de la cotización ha sido copiado al portapapeles.', 'success');
               }
            }}
         />

      </>
   )
}

export default ModalCreatePreOrder